//Angular imports
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

//3rd party imports
import { plainToInstance } from 'class-transformer';

//RxJs imports
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

//Service imports
import { RPCacheRegistrationService } from '../../../_services/shared-services/rp-cache-registration-service';
import { HelperService } from '../../../_services/shared-services/helper.service';

//Model imports
import { ViolationParameterDto } from '../../_models/violation-parameter-dto';
import { ViolationResultDto } from '../../_models/violation-result-dto';
import { ViolationHistoryParameterDto } from '../../_models/violation-history-parameter-dto';
import { ViolationHistoryResultDto } from '../../_models/violation-history-result-dto';

//Service imports
import { EnvironmentConfigService } from '../../../_services/environment-config.service';

//Constants imports
import { CacheDuration } from '../../../_constants/cache-duration';

@Injectable({
  providedIn: 'root'
})
export class AccountComplianceService {
  constructor(
    private httpClient: HttpClient,
    private helperService: HelperService,
    private cacheRegistrationService: RPCacheRegistrationService,
    private envConfig: EnvironmentConfigService
  ) {}

  getAccountViolations(
    data: ViolationParameterDto
  ): Observable<ViolationResultDto[]> {
    let url =
      this.envConfig.ccResidentPortalApiUrl +
      'account/violations' +
      data.getQueryString();
    if (!!data.periodBegin && !!data.periodEnd) {
      const periodBegin = this.helperService.getISODateString(data.periodBegin);
      const periodEnd = this.helperService.getISODateString(data.periodEnd);
      url = url + `&periodBegin=${periodBegin}&periodEnd=${periodEnd}`;
    }

    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<ViolationResultDto[]>(url, options)
      .pipe(
        map((responseData: ViolationResultDto[]) =>
          plainToInstance(ViolationResultDto, responseData)
        )
      );
  }

  getAccountViolationDetails(
    data: ViolationHistoryParameterDto
  ): Observable<ViolationHistoryResultDto[]> {
    const url =
      this.envConfig.ccResidentPortalApiUrl +
      'account/violations/history' +
      data.getQueryString();
    this.cacheRegistrationService.registerForCache(url, data.clearCache);
    const headers = this.cacheRegistrationService.getHttpRequestHeaders(
      url,
      CacheDuration.fifteenMinute
    );
    const options = { headers: headers };

    return this.httpClient
      .get<ViolationHistoryResultDto[]>(url, options)
      .pipe(
        map((responseData: ViolationHistoryResultDto[]) =>
          plainToInstance(ViolationHistoryResultDto, responseData)
        )
      );
  }

  downloadFile(fileUrl: string): Observable<Blob> {
    return this.httpClient
      .get(fileUrl, { responseType: 'arraybuffer' })
      .pipe(map((responseData: any) => new Blob([responseData])));
  }
}
